<template>
  <div>
    <h4 class="media align-items-center font-weight-bold py-3 mb-4">
      <div class="media-body ml-3">
        Bienvenido, {{ $session.get("Nombres") }}!
        <div class="text-muted text-tiny mt-1">
          <dashboard-live-clock></dashboard-live-clock>
        </div>
      </div>
    </h4>
    <hr class="container-m-nx mt-0 mb-4" />
    <div class="card card-custom mb-3">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">
            <select v-model="regionSeleccionada">
              <option :value="null">Todas las regiones</option>
              <option v-for="item in regionesSinLimaMetropolitana" :value="item" :key="item.regionId">{{ item.nombre }}</option>
            </select>

            <span v-if="filtro.regionId || filtro.subRegionId">
              <i class="fa fa-chevron-right mx-2"></i>

              <select v-model="subRegionSeleccionada">
                <option :value="null">Todas las subregiones</option>
                <option v-for="item in subRegionesPorRegionFiltrada" :value="item" :key="item.subRegionId">{{ item.nombre }}</option>
              </select>
            </span>
            <b-btn v-if="filtro.regionId || filtro.subRegionId" variant="default" @click="borrarFiltroRegion" class="ml-2"><i class="fa fa-times"></i></b-btn>
          </h3>
        </div>
        <div class="card-toolbar">
          <dashboard-auto-refresh :intervalo-segundos="300" @refresh="onRefreshAutomatico"></dashboard-auto-refresh>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="d-flex col-xl-6 align-items-stretch">
        <b-card no-body class="w-100 mb-4 ">
          <b-card-body class="p-0">
            <div class="map-wrapper" style="width:100%">
              <highcharts v-if="chartOptionsPeru" :constructorType="'mapChart'" :options="chartOptionsPeru" :deepCopyOnUpdate="false" :updateArgs="[true, false]" :callback="onMapChartReady" ref="chartPeru"></highcharts>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="d-flex col-xl-6 ">
        <!-- 
          
        <div class="row">
          <div class="card" style="">
            <div class="card-body">
              <span class="card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 d-block"> <span class="font-weight-bolder">25</span> % </span>
              <span class="font-weight-bold text-muted font-size-sm">Avance Turno 1</span>
            </div>
          </div>
        </div>

         -->

        <div class="w-100 mb-4">
          <div class="row no-gutters row-bordered h-100">
            <div class="card col-xl-12 col-lg-12" style="">
              <div @click.prevent="turnoMapaSeleccionado = null" :class="[turnoMapaSeleccionado == null ? 'bg-light' : '']" class="card-body p-2  cursor-pointer" style="flex-direction: column;display: flex;align-items: center;justify-content: center;">
                <span class="card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 d-block">
                  <span class="font-weight-bolder">{{ datosAvanceGeneral.all }}</span> %
                </span>
                <span class="font-weight-bold text-muted font-size-sm">Avance General</span>
              </div>
            </div>
            <div class="card col-xl-6 col-lg-6" style="">
              <div @click.prevent="turnoMapaSeleccionado = 1" :class="[turnoMapaSeleccionado == 1 ? 'bg-light' : '']" class="card-body p-2  cursor-pointer" style="flex-direction: column;display: flex;align-items: center;justify-content: center;">
                <span class="card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 d-block">
                  <span class="font-weight-bolder">{{ datosAvanceGeneral.t1 }}</span> %
                </span>
                <span class="font-weight-bold text-muted font-size-sm">Avance Turno 1</span>
              </div>
            </div>
            <div class="card col-xl-6 col-lg-6" style="">
              <div @click.prevent="turnoMapaSeleccionado = 2" :class="[turnoMapaSeleccionado == 2 ? 'bg-light' : '']" class="card-body p-2  cursor-pointer" style="flex-direction: column;display: flex;align-items: center;justify-content: center;">
                <span class="card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 d-block">
                  <span class="font-weight-bolder">{{ datosAvanceGeneral.t2 }}</span> %
                </span>
                <span class="font-weight-bold text-muted font-size-sm">Avance Turno 2</span>
              </div>
            </div>
            <!-- <div class="card col-xl-6 col-lg-6" style="">
              <div @click.prevent="turnoMapaSeleccionado = 3" :class="[turnoMapaSeleccionado == 3 ? 'bg-light' : '']" class="card-body p-2  cursor-pointer" style="flex-direction: column;display: flex;align-items: center;justify-content: center;">
                <span class="card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 d-block">
                  <span class="font-weight-bolder">{{ datosAvanceGeneral.t3 }}</span> %
                </span>
                <span class="font-weight-bold text-muted font-size-sm">Avance Turno 3</span>
              </div>
            </div> -->
            <!-- <div class="card col-xl-6 col-lg-6" style="">
              <div @click.prevent="turnoMapaSeleccionado = 4" :class="[turnoMapaSeleccionado == 4 ? 'bg-light' : '']" class="card-body p-2  cursor-pointer" style="flex-direction: column;display: flex;align-items: center;justify-content: center;">
                <span class="card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 d-block">
                  <span class="font-weight-bolder">{{ datosAvanceGeneral.t4 }}</span> %
                </span>
                <span class="font-weight-bold text-muted font-size-sm">Avance Turno 4</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>


    <div v-if="reporteAvanceTerritorio" class="row">
      <div :class="columnaReporte(reporteAvanceTerritorio)">
        <data-chart-card v-if="reporteAvanceTerritorio.configuracionVisualizacion.tipoChart == 'DATA-CHART'" class="" :title="reporteAvanceTerritorio.configuracionVisualizacion.configDataChart.title" :colores="reporteAvanceTerritorio.configuracionVisualizacion.configStyle.colores" :height="reporteAvanceTerritorio.configuracionVisualizacion.configDataChart.height" :defaultView="reporteAvanceTerritorio.configuracionVisualizacion.configDataChart.defaultView" :section="reporteAvanceTerritorio.configuracionVisualizacion.configDataChart.section" :code="reporteAvanceTerritorio.configuracionVisualizacion.configDataChart.code" :filaTieneTitulo="reporteAvanceTerritorio.configuracionVisualizacion.configDataChart.filaTieneTitulo" :allowTableExceedHeight="reporteAvanceTerritorio.configuracionVisualizacion.configDataChart.allowTableExceedHeight" :pivotTable="reporteAvanceTerritorio.configuracionVisualizacion.configDataChart.pivotTable" :pivotReportData="reporteAvanceTerritorio.configuracionVisualizacion.configDataChart.pivotReportData" :chartType="reporteAvanceTerritorio.configuracionVisualizacion.configDataChart.chartType" :procesoElectoralId="filtro.procesoElectoralId" :localVotacionId="filtro.localVotacionId" :regionId="filtro.regionId" :subRegionId="filtro.subRegionId" :reporteDataId="reporteAvanceTerritorio.reporteDataId" :key="'avance-' + actualizacionAutomatica.forceUpdateKey + '-' + (filtro.regionId || 'all')"></data-chart-card>
      </div>
    </div>

    <div v-for="(sectionTurno, indexSectionTurno) in estructuraReportesTurnosLocales" :key="'prov-turno-' + indexSectionTurno">
      <div class="card card-custom mb-3">
        <div class="card-header">
          <div class="card-title" @click.prevent="sectionTurno.expandirContenido = !sectionTurno.expandirContenido">
            <h3 class="card-label cursor-pointer"><span class="label label-xl label-dot mr-2" :class="[sectionTurno.dotStyle]"></span> {{ sectionTurno.titulo }} <i class="mr-2"></i></h3>
          </div>
          <div class="card-toolbar">
            <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="sectionTurno.expandirContenido = !sectionTurno.expandirContenido"><i class="fa p-0" :class="[sectionTurno.expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
          </div>
        </div>
      </div>

      <div v-if="sectionTurno.expandirContenido">
          <div v-for="(corte, indexCorte) in sectionTurno.cortes" :key="'prov-corte-' + indexSectionTurno + '-' + indexCorte">
          <div class="card card-custom mb-2 corte-franja">
            <div class="card-header corte-franja-header" :class="corte.headerClass" @click.prevent="corte.expandirContenido = !corte.expandirContenido">
              <div class="card-title mb-0">
                <h3 class="card-label cursor-pointer mb-0">{{ corte.titulo }}</h3>
              </div>
              <div class="card-toolbar">
                <i class="fa p-0" :class="[corte.expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
              </div>
            </div>
          </div>

          <template v-if="corte.expandirContenido">
          <div v-for="(fila, indexFila) in corte.filas" :key="'prov-fila-' + indexSectionTurno + '-' + indexCorte + '-' + indexFila" class="row dashboard-fila-widgets">
            <div v-for="celda in fila" :key="celda.item.reporteDataId" :class="celda.colClass" class="d-flex">
              <data-chart-card v-if="celda.item.configuracionVisualizacion.tipoChart == 'DATA-CHART'" class="w-100 h-100 d-flex" :title="celda.item.configuracionVisualizacion.configDataChart.title" :colores="celda.item.configuracionVisualizacion.configStyle.colores" :height="celda.item.configuracionVisualizacion.configDataChart.height" :defaultView="celda.item.configuracionVisualizacion.configDataChart.defaultView" :section="celda.item.configuracionVisualizacion.configDataChart.section" :code="celda.item.configuracionVisualizacion.configDataChart.code" :filaTieneTitulo="celda.item.configuracionVisualizacion.configDataChart.filaTieneTitulo" :allowTableExceedHeight="celda.item.configuracionVisualizacion.configDataChart.allowTableExceedHeight" :pivotTable="celda.item.configuracionVisualizacion.configDataChart.pivotTable" :pivotReportData="celda.item.configuracionVisualizacion.configDataChart.pivotReportData" :chartType="celda.item.configuracionVisualizacion.configDataChart.chartType" :procesoElectoralId="filtro.procesoElectoralId" :localVotacionId="filtro.localVotacionId" :regionId="filtro.regionId" :subRegionId="filtro.subRegionId" :reporteDataId="celda.item.reporteDataId" :key="'chart-' + actualizacionAutomatica.forceUpdateKey + '-' + celda.item.reporteDataId"></data-chart-card>
              <single-data-card v-if="celda.item.configuracionVisualizacion.tipoChart == 'SINGLE'" class="w-100 h-100" :title="celda.item.configuracionVisualizacion.configSingle.title" :colores="celda.item.configuracionVisualizacion.configStyle.colores" :suffix="celda.item.configuracionVisualizacion.configSingle.suffix" :iconClass="celda.item.configuracionVisualizacion.configSingle.iconClass" :section="celda.item.configuracionVisualizacion.configSingle.section" :code="celda.item.configuracionVisualizacion.configSingle.code" :filaTieneTitulo="celda.item.configuracionVisualizacion.configSingle.filaTieneTitulo" :column="celda.item.configuracionVisualizacion.configSingle.column" :columnIndex="celda.item.configuracionVisualizacion.configSingle.columnIndex" :rowIndex="celda.item.configuracionVisualizacion.configSingle.rowIndex" :pivotReportData="celda.item.configuracionVisualizacion.configSingle.pivotReportData" :procesoElectoralId="filtro.procesoElectoralId" :localVotacionId="filtro.localVotacionId" :regionId="filtro.regionId" :subRegionId="filtro.subRegionId" :reporteDataId="celda.item.reporteDataId" :key="'single-' + actualizacionAutomatica.forceUpdateKey + '-' + celda.item.reporteDataId"></single-data-card>
            </div>
          </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<style>
.map-tooltip {
  color: white;
  text-align: center;
  height: 150px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-family: "Montserrat", "Segoe UI", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.map-tooltip-title {
  font-size: 17px;
  font-weight: bold;
  width: 150px;
  white-space: normal;
  display: block;
}

.map-tooltip-detail {
  align-items: center;
  display: flex;
  justify-content: center;
}

.map-tooltip-detail i {
  font-size: 30px;
}

.map-tooltip-value {
  font-size: 16px;
  font-weight: bold;
}

.map-tooltip-text-inscritos {}

/* Un poco mayor que .card-header .card-title en gráficos (tema ~1.275rem) */
.reportes-vista-toggle .btn {
  min-width: 7rem;
  font-size: 1.35rem;
  line-height: 1.3;
}

.corte-franja.card-custom > .corte-franja-header {
  min-height: 36px;
  height: auto;
  padding: 0.4rem 1.25rem;
  cursor: pointer;
  border-bottom: 0;
}

.corte-franja .corte-franja-header .card-title {
  margin: 0;
}

.corte-franja .corte-franja-header .card-label {
  font-size: 1rem;
  font-weight: 600;
}

.corte-franja-header.bg-light-primary {
  background-color: #e1f0ff !important;
  color: #3699ff;
}

.corte-franja-header.bg-light-danger {
  background-color: #ffe2e5 !important;
  color: #f64e60;
}

.corte-franja-header.bg-light-primary .card-label,
.corte-franja-header.bg-light-danger .card-label {
  color: inherit;
}

.dashboard-fila-widgets {
  align-items: stretch;
}

.dashboard-fila-widgets > [class*="col-"] {
  display: flex;
}

.dashboard-fila-widgets > [class*="col-"] > * {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  min-height: 100%;
}

.dashboard-fila-widgets .card {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
}
</style>

<script>
import Vue from "vue";
import moment from "moment";

import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import HighchartsMapModule from "highcharts/modules/map";
import peruMap from "@highcharts/map-collection/countries/pe/pe-all.geo.json";

import dataChartCard from "@/components/report/data-chart-card";
import singleDataCard from "@/components/report/single-data-card";
import dashboardLiveClock from "@/components/report/dashboard-live-clock";
import dashboardAutoRefresh from "@/components/report/dashboard-auto-refresh";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

if (typeof Highcharts.mapChart !== "function") {
  HighchartsMapModule(Highcharts);
}

export default {
  name: "DashboardAdminRegiones",
  metaInfo: {
    title: "Regiones",
  },
  components: {
    highcharts: Chart,
    dataChartCard,
    singleDataCard,
    dashboardLiveClock,
    dashboardAutoRefresh,
  },
  data: () => ({
    moment: moment,
    fechaUltimaActualizacion: null,
    actualizacionAutomatica: {
      forceUpdateKey: 1,
    },
    chartOptionsPeru: null,

    regiones: [],
    subRegiones: [],

    regionSeleccionada: null,
    subRegionSeleccionada: null,

    filtro: {
      procesoElectoralId: 0,
      localVotacionId: null,
      regionId: null,
      regionNombre: null,
      subRegionId: null,
      subRegionNombre: null,
    },
    datosMapaPeru: [],
    datosAvanceGeneral: { all: 0, t1: 0, t2: 0 },
    turnoMapaSeleccionado: null,
    estructuraReportesTurnosLocales: [],
    reportesGenericos: [
      /*
    {
      reporteDataId: null,
      seccion: null,
      codigo: null,
      titulo: null,
      subTitulo: null,
      descripcion: null,
      sentenciaSelect: null,
      sentenciaOrderBy: null,
      sentenciaJsonFormat: null,
      sentenciaParametros: "",
      configuracionVisualizacion: null,

      esEliminado: false,
    }

      configuracionVisualizacion: {
        tipoChart: "DATA-CHART",
          configDataChart: {
            title: "",
            height: null,
            defaultView: null, //["table", "chart"],
            section: "",
            code: "",
            filaTieneTitulo: true,
            allowTableExceedHeight: true,
            pivotTable: false,
            pivotReportData: false,
            chartType: null, //["pie", "chart", "bar"],
            componentForceUpdateKey: 0,
          },
          configSingle: {
            title: "",
            prefix: null,
            suffix: null,
            iconClass: "fa fa-chart-area",
            section: null,
            code: null,
            filaTieneTitulo: false,
            column: null,
            columnIndex: null,
            rowIndex: null,
            pivotReportData: false,
            componentForceUpdateKey: 0,
            rawDataForceUpdateKey: -1,
          },
          configStyle: {
            colClass: "col-sm-6 col-xl-4 col-xxl-3",
            orden: 1,
          },
      }*/
    ],
  }),
  computed: {
    regionesSinLimaMetropolitana: function () {
      return (this.regiones || []).filter(function (x) {
        return (x.nombre || "").toLowerCase().indexOf("lima metropolitana") === -1;
      });
    },

    subRegionesPorRegionFiltrada: function () {
      if (!this.filtro.regionId) return [];

      return this.subRegiones.filter((x) => x.regionId == this.filtro.regionId);
    },

    reporteAvanceTerritorio: function () {
      if (!this.reportesGenericos) return null;
      var codigo = this.filtro.regionId ? "AvanceSubregiones" : "AvanceRegiones";
      return this.reportesGenericos.find((x) => x.seccion == "DB-ERM_PROV_2026-GEN" && x.codigo == codigo) || null;
    },

    serieDatosMapaPeru: function () {
      var serie = [];
      if (this.datosMapaPeru) {
        for (let i = 0; i < this.datosMapaPeru.length; i++) {
          var data = this.datosMapaPeru[i];
          var porcentaje = data.all;

          switch (this.turnoMapaSeleccionado) {
            case 1:
              porcentaje = data.t1;
              break;
            case 2:
              porcentaje = data.t2;
              break;
            // case 3:
            //   porcentaje = data.t3;
            //   break;
            // case 4:
            //   porcentaje = data.t4;
            //   break;
            // case 5:
            //   porcentaje = data.t5;
            //   break;
          }

          var codigos = (data.codigoMapa || "").split("|").filter(Boolean);
          if (codigos.length === 0) continue;

          var color = "#d4d6dd";

          if (porcentaje > 0) {
            color = "#f64e60"; //rojo
          }

          if (porcentaje > 75) {
            color = "#ffa800"; //amarillo
          }

          if (porcentaje > 95) {
            color = "#1bc5bd"; //verde
          }

          for (let c = 0; c < codigos.length; c++) {
            serie.push([codigos[c], porcentaje, data.region, data.regionId, color]);
          }
        }
      }
      return serie;
    },
  },
  methods: {
    buildChartOptionsPeru: function () {
      var vm = this;
      return Object.freeze({
        chart: {
          map: peruMap,
          backgroundColor: "rgba(0,0,0,0)",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            alignTo: "spacingBox",
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          map: {
            nullColor: "#808285",
          },
          series: {
            animation: false,
            point: {
              events: {
                click: function () {
                  var regionId = this.regionId;
                  var encontrada = vm.regionesSinLimaMetropolitana.find(function (x) {
                    return x.regionId == regionId;
                  });
                  if (encontrada) {
                    vm.regionSeleccionada = encontrada;
                  }
                },
              },
            },
          },
        },
        tooltip: {
          followPointer: false,
          pointFormat: "{point.nombre}: {point.value}%",
        },
        series: [
          {
            keys: ["hc-key", "value", "nombre", "regionId", "color"],
            name: "Avance",
            states: {
              hover: {
                color: null,
                brightness: -0.1,
              },
            },
            dataLabels: {
              enabled: false,
              format: "{point.name} %",
            },
            allAreas: true,
            data: [],
          },
        ],
      });
    },

    aplicarDatosMapa: function () {
      var cmp = this.$refs.chartPeru;
      var chart = cmp && cmp.chart;
      if (!chart || !chart.series || !chart.series[0]) return;
      chart.series[0].setData(this.serieDatosMapaPeru.slice(), true, false);
    },

    onMapChartReady: function (chart) {
      if (!chart || !chart.series || !chart.series[0]) return;
      chart.series[0].setData(this.serieDatosMapaPeru.slice(), true, false);
    },

    onRefreshAutomatico: function () {
      this.actualizacionAutomatica.forceUpdateKey += 1;
      this.fetchEstadisticasMapa();
      this.fetchEstadisticasTurnos();
    },

    generateEstructuraReportesGenericosTurnos: function () {
      if (!this.reportesGenericos) {
        this.estructuraReportesTurnosLocales = [];
        return;
      }

      var t1c1 = this.reportesGenericos.filter((x) => x.seccion == "DB-ERM_PROV_2026-T1-C1");
      var t1c2 = this.reportesGenericos.filter((x) => x.seccion == "DB-ERM_PROV_2026-T1-C2");
      var t2c1 = this.reportesGenericos.filter((x) => x.seccion == "DB-ERM_PROV_2026-T2-C1");
      var t2c2 = this.reportesGenericos.filter((x) => x.seccion == "DB-ERM_PROV_2026-T2-C2");

      this.estructuraReportesTurnosLocales = [
        {
          titulo: "Turno 1",
          dotStyle: "label-primary",
          expandirContenido: true,
          cortes: [
            {
              titulo: "Corte 1 · 9:00 a.m. · secciones 2–5",
              headerClass: "bg-light-primary",
              expandirContenido: true,
              reportes: t1c1,
              filas: this.filasWidgets(t1c1),
            },
            {
              titulo: "Corte 2 · 12:30 p.m. · secciones 6–7",
              headerClass: "bg-light-primary",
              expandirContenido: false,
              reportes: t1c2,
              filas: this.filasWidgets(t1c2),
            },
          ],
        },
        {
          titulo: "Turno 2",
          dotStyle: "label-danger",
          expandirContenido: true,
          cortes: [
            {
              titulo: "Corte 1 · 15:30 · secciones 2–4",
              headerClass: "bg-light-danger",
              expandirContenido: true,
              reportes: t2c1,
              filas: this.filasWidgets(t2c1),
            },
            {
              titulo: "Corte 2 · 18:00 · secciones 5–8",
              headerClass: "bg-light-danger",
              expandirContenido: false,
              reportes: t2c2,
              filas: this.filasWidgets(t2c2),
            },
          ],
        },
      ];
    },

    columnaReporte: function (item) {
      if (item && item.configuracionVisualizacion && item.configuracionVisualizacion.configStyle && item.configuracionVisualizacion.configStyle.colClass) {
        return item.configuracionVisualizacion.configStyle.colClass;
      }
      return "col-xl-4";
    },

    spanColumnaXl: function (item) {
      var clase = this.columnaReporte(item) || "";
      var match = clase.match(/col-xl-(\d+)/);
      if (match) {
        var n = parseInt(match[1], 10);
        if (n >= 1 && n <= 12) {
          return n;
        }
      }
      return 4;
    },

    columnasRepartidas: function (cantidad) {
      var base = Math.floor(12 / cantidad);
      var extra = 12 % cantidad;
      var spans = [];
      for (var i = 0; i < cantidad; i++) {
        spans.push(base + (i < extra ? 1 : 0));
      }
      return spans;
    },

    celdasFilaCompleta: function (items) {
      var spans = this.columnasRepartidas(items.length);
      return items.map(function (item, i) {
        return {
          item: item,
          colClass: "col-12 col-md-6 col-xl-" + spans[i],
        };
      });
    },

    filasWidgets: function (reportes) {
      var filas = [];
      var filaActual = [];
      var ocupado = 0;
      var self = this;
      (reportes || []).forEach(function (item) {
        var span = self.spanColumnaXl(item);
        if (filaActual.length && ocupado + span > 12) {
          filas.push(self.celdasFilaCompleta(filaActual));
          filaActual = [];
          ocupado = 0;
        }
        filaActual.push(item);
        ocupado += span;
        if (ocupado >= 12) {
          filas.push(self.celdasFilaCompleta(filaActual));
          filaActual = [];
          ocupado = 0;
        }
      });
      if (filaActual.length) {
        filas.push(self.celdasFilaCompleta(filaActual));
      }
      return filas;
    },

    borrarFiltroRegion: function () {
      this.filtro.regionId = null;
      this.filtro.regionNombre = null;
      this.filtro.subRegionId = null;
      this.filtro.subRegionNombre = null;
      this.regionSeleccionada = null;
      this.subRegionSeleccionada = null;
    },

    setRegion: function (nombre, id) {
      this.filtro.regionId = id;
      this.filtro.regionNombre = nombre;
      this.filtro.subRegionId = null;
      this.filtro.subRegionNombre = null;
      this.subRegionSeleccionada = null;
    },
    setSubRegion: function (nombre, id) {
      //this.filtro.regionId = null;
      //this.filtro.regionNombre = null;
      this.filtro.subRegionId = id;
      this.filtro.subRegionNombre = nombre;
    },
    fetchEstadisticasMapa: async function () {
      var params = {
        procesoElectoralId: this.filtro.procesoElectoralId,
        localVotacionId: this.filtro.localVotacionId,
        regionId: this.filtro.regionId,
        subRegionId: this.filtro.subRegionId,
      };

      var model = {
        seccion: "DB-ERM_PROV_2026-GEN",
        codigo: "AvanceMapa",
        filaTieneTitulo: false,
        parametros: { ...params },
      };
      await this.$http.post(this.apiRoute("ReportData", "GetJson"), model).then(function (response) {
        if (!response.body.error) {
          var data = response.body.data;
          this.datosMapaPeru = Array.isArray(data) ? data : data ? [data] : [];
        }
      });
    },

    fetchEstadisticasTurnos: async function () {
      var params = {
        procesoElectoralId: this.filtro.procesoElectoralId,
        localVotacionId: this.filtro.localVotacionId,
        regionId: this.filtro.regionId,
        subRegionId: this.filtro.subRegionId,
      };

      var model = {
        seccion: "DB-ERM_PROV_2026-GEN",
        codigo: "Avance",
        filaTieneTitulo: false,
        parametros: { ...params },
      };
      await this.$http.post(this.apiRoute("ReportData", "GetJson"), model).then(function (response) {
        if (!response.body.error && response.body.data.length > 0) {
          this.datosAvanceGeneral = response.body.data[0];
        }
      });
    },

    fetchReportesGenericos: function () {
      this.showLoading();
      var model = {
        seccion: "DB-ERM_PROV_2026",
        pagination: { paginate: false, page: 1, size: 200 },
      };
      this.$http.post(this.apiRoute("ReportData", "ListReportes"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var reportesGenericosTemp = [];

          for (var i = 0; i < response.body.data.items.length; i++) {
            var reporteGenericoTemp = response.body.data.items[i];
            if (!reporteGenericoTemp.configuracionVisualizacion) continue;

            reporteGenericoTemp.configuracionVisualizacion = JSON.parse(reporteGenericoTemp.configuracionVisualizacion || "{}");
            reportesGenericosTemp.push(reporteGenericoTemp);
          }

          this.reportesGenericos = reportesGenericosTemp;
          this.generateEstructuraReportesGenericosTurnos();
          this.showLoading(false);
        }
      });
    },

    fetchRegiones: function () {
      var modelRegion = {};

      this.$http.post(this.apiRoute("Region", "ListRegiones"), modelRegion).then(function (response) {
        this.regiones = response.body.data.items;
      });
    },

    fetchSubRegiones: function () {
      var modelSubRegion = {};

      this.$http.post(this.apiRoute("Region", "ListSubRegiones"), modelSubRegion).then(function (response) {
        this.subRegiones = response.body.data.items;
      });
    },
    onIncidenteRegistrado: function (params) {
      console.log("Incidente Registrado");
      console.log(params);
      //tipo, localNombre, localDireccion, localSubRegion, localRegion

      var tipoString = "";
      switch (params.tipo) {
        case "ACTO":
          tipoString = "Acto de Violencia";
          break;
        case "OTROS":
          tipoString = "Incidente (otros)";
          break;
      }

      var detail = 'Registrado en el local "' + params.localNombre + '" ubicado en ' + params.localRegion + " / " + params.localSubRegion + ".";

      this.$bvToast.toast(detail, {
        title: tipoString + " en " + params.localSubRegion,
        autoHideDelay: 5 * 60 * 1000,
        variant: "danger",
        appendToast: false,
        solid: true,
        noAutoHide: true,
      });
    },
  },
  watch: {
    regionSeleccionada: function (newValue, oldValue) {
      if (newValue) {
        this.setRegion(newValue.nombre, newValue.regionId);
      } else {
        this.setRegion(null, null);
      }
    },
    subRegionSeleccionada: function (newValue, oldValue) {
      if (newValue) {
        this.setSubRegion(newValue.nombre, newValue.subRegionId);
      } else {
        this.setSubRegion(null, null);
      }
    },
    "filtro.regionId": function () {
      this.fetchEstadisticasMapa();
      this.fetchEstadisticasTurnos();
    },
    "filtro.subRegionId": function () {
      this.fetchEstadisticasMapa();
      this.fetchEstadisticasTurnos();
    },
    serieDatosMapaPeru: function () {
      this.$nextTick(this.aplicarDatosMapa);
    },
  },
  created() {
    this.chartOptionsPeru = this.buildChartOptionsPeru();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Seguimiento" }, { title: "Regiones" }]);
    this.moment.locale("es");
    this.filtro.procesoElectoralId = this.$session.get("ProcesoElectoralId");
    this.fetchEstadisticasMapa();
    this.fetchEstadisticasTurnos();
    this.fetchReportesGenericos();
    this.fetchRegiones();
    this.fetchSubRegiones();

    var vm = this;
    setTimeout(function () {
      vm.$notifyHub.subscribeFichaGroup("ADM-DASHBOARD");
      vm.$notifyHub.$on("incidente-registrado", vm.onIncidenteRegistrado);
    }, 1000);
  },
  beforeDestroy() {
    this.$notifyHub.unsubscribeFichaGroup("ADM-DASHBOARD");
    this.$notifyHub.$off("incidente-registrado", this.onIncidenteRegistrado);
  },
};
</script>
